import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toDay' })
export class ToDay implements PipeTransform {
  days = [
    'Vasárnap',
    'Hétfő',
    'Kedd',
    'Szerda',
    'Csütörtök',
    'Péntek',
    'Szombat',
  ];

  transform(date: string) {
    return this.days[new Date(date).getDay()];
  }
}
